export default {
  state: {
    small: '18px',
    medium: '20px',
    large: '22px'
  },
  mutations: {},
  actions: {}
};
